import { render } from "./term.vue?vue&type=template&id=b8e7e366&scoped=true"
import script from "./term.vue?vue&type=script&lang=js"
export * from "./term.vue?vue&type=script&lang=js"

import "./term.vue?vue&type=style&index=0&id=b8e7e366&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e7e366"]])

export default __exports__